import { PortalLinkedItemType } from "@/Common/Models/Portal/Enums/PortalLinkedItemType";
import { SharedItemMessage } from "@/Common/Models/Portal/SharedItem/SharedItemMessage";
import { SharedItemPriority } from "@/Common/Models/Portal/SharedItem/SharedItemPriority";
import { IPortalLinkedItemModel } from "@/Common/Models/Portal/UI/IPortalLinkedItemModel";
import { sharedItemProviderFactory } from "@/Portal/Services/SharedItemProviderFactory";
import { ISendToPortalPopupStrategy } from "./ISendToPortalPopupStrategy";

export abstract class BaseSendToPortalPopupStrategy implements ISendToPortalPopupStrategy {
    private readonly _revokeClickOperation: number;
    private readonly _closePopupClickOperation: number;

    public readonly linkedItemType: PortalLinkedItemType;
    public readonly sendToPortalLabel: string;
    public readonly sharedItemTypeLabel: string;
    public readonly canEditMessage: boolean;

    public get canCheckItem(): boolean {
        return true;
    }

    public get shouldShowSubject(): boolean {
        return this.linkedItemType !== PortalLinkedItemType.CommunicationHistory;
    }

    public abstract readonly disclaimer: string;
    public abstract readonly itemCheckOperation: number;

    public get itemIconClass(): string {
        return sharedItemProviderFactory.get(this.linkedItemType).getItemIconClass();
    }

    constructor(
        linkedItemType: PortalLinkedItemType,
        revokeClickOperation: number,
        closePopupClickOperation: number,
        sendToPortalLabelOverride: string = null
    ) {
        this.linkedItemType = linkedItemType;
        this._revokeClickOperation = revokeClickOperation;
        this._closePopupClickOperation = closePopupClickOperation;
        this.sendToPortalLabel = sendToPortalLabelOverride || cacheStore.GetString("SyncToPatientPortal");

        this.sharedItemTypeLabel = sharedItemProviderFactory.get(this.linkedItemType).getSharedItemTypeLabel();
        this.canEditMessage = linkedItemType !== PortalLinkedItemType.CommunicationHistory;
    }

    public onRevokeClick(): void {
        sessionStore.dispatch(this._revokeClickOperation);
    }

    public onClosePopupClick(): void {
        sessionStore.dispatch(this._closePopupClickOperation);
    }

    public abstract onSendToPortalClick(subject: string, newMessage: string, includeDocument: boolean, portalItemModel?: IPortalLinkedItemModel, priority?: SharedItemPriority, canPatientReplyWithMessage?: boolean);

    public onSendToPortalClickAsync(subject: string, newMessage: string, includeDocument: boolean, portalItemModel?: IPortalLinkedItemModel, priority?: SharedItemPriority, canPatientReplyWithMessage?: boolean): Promise<boolean> {
        this.onSendToPortalClick(subject, newMessage, includeDocument, portalItemModel, priority, canPatientReplyWithMessage);
        console.warn(`Not used ${portalItemModel}`);
        return Promise.resolve(true);
    }

    public onRevokeClickAsync(portalItemModel: IPortalLinkedItemModel): Promise<boolean> {
        this.onRevokeClick();
        console.warn(`Not used ${portalItemModel}`);
        return Promise.resolve(true);
    }

    public onPortalSharedItemMessageCheckChange(portalItemModel: IPortalLinkedItemModel, message: SharedItemMessage): Immutable.List<SharedItemMessage> {
        throw new Error(`Not implemented ${portalItemModel} ${message}`);
    }
}
